import { Box, Button, Grid, Stack, Typography } from "@mui/material"
import EmployeeHeadShot from "@/components/about/EmployeeProfiles"
import useDialogState from "@/hooks/useDialogState"
import AdSpaceDialog from "@/dialogs/AdSpaceDialog"
import RecommendEventDialog from "@/dialogs/RecommendEventDialog"
import ExpandNearYouDialog from "@/dialogs/ExpandNearYouDialog"
import ServiceCard from "@/components/about/ServiceCard"
import seoImg from "../common/images/seo_img.png"
import socialImg from "../common/images/social_img.png"
import webDevImg from "../common/images/webdev_img.png"
import videoImage from "../common/images/video_img.png"
import AboutUsFooter from "@/components/about/AboutUsFooter"
import useIsMobile from "@/hooks/useIsMobile"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import wyattHeadshot from "@/common/images/team/wyatt_headshot.jpg"
import tyreseHeadshot from "@/common/images/team/tyrese_headshot.jpg"
import madisonHeadshot from "@/common/images/team/madison_headshot.jpg"
import useIsTablet from "@/hooks/useIsTablet"

const AboutUs = () => {
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()
  const location = useLocation()
  const navigate = useNavigate()
  const {
    openDialog: openAdSpace,
    closeDialog: closeAdSpace,
    isOpen: adSpaceOpen,
  } = useDialogState({})
  const {
    openDialog: openRecommend,
    closeDialog: closeRecommend,
    isOpen: recommendOpen,
  } = useDialogState({})
  const {
    openDialog: openExpand,
    closeDialog: closeExpand,
    isOpen: expandOpen,
  } = useDialogState({})

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.has("adForm")) {
      openAdSpace({})
    } else if (params.has("recommendForm")) {
      openRecommend({})
    } else if (params.has("expandForm")) {
      openExpand({})
    }
  }, [location.search, openAdSpace, openRecommend, openExpand])

  const handleAdClose = () => {
    closeAdSpace()
    navigate(location.pathname) // Remove query param when closing
  }

  const handleRecommendClose = () => {
    closeRecommend()
    navigate(location.pathname)
  }

  const handleExpandClose = () => {
    closeExpand()
    navigate(location.pathname)
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Stack
          spacing={2}
          alignItems="center"
          sx={{
            height: "100%",
            width: "100%",
            backgroundColor: "#1A2958",
          }}
        >
          <Typography variant="h1" color="white" fontSize={isMobile ? 32 : 64}>
            Meet The Team
          </Typography>
          {isMobile || isTablet ? (
            <Grid container>
              <Grid item xs={6}>
                <EmployeeHeadShot
                  image={wyattHeadshot}
                  name="Wyatt Slominski"
                  position="Founder"
                />
              </Grid>
              <Grid item xs={6}>
                <EmployeeHeadShot
                  image={tyreseHeadshot}
                  name="Tyrese Brown"
                  position="Owner"
                />
              </Grid>
              <Grid item xs={12}>
                <EmployeeHeadShot
                  image={madisonHeadshot}
                  name="Madison Sinatra"
                  position="Owner"
                />
              </Grid>
              {/* <Grid item xs={6}>
                <EmployeeHeadShot
                  image="https://eightfourthree-events.s3.us-east-2.amazonaws.com/testing/horizontal_image.png"
                  name="Randall Schwemmer"
                  position="Developer"
                />
              </Grid> */}
            </Grid>
          ) : (
            <Box
              display="flex"
              flexDirection={isMobile ? "column" : "row"}
              alignItems="center"
              width="90%"
              justifyContent="space-between"
              paddingX={isMobile ? 0 : 8}
            >
              <EmployeeHeadShot
                image={wyattHeadshot}
                name="Wyatt Slominski"
                position="Founder"
              />
              <EmployeeHeadShot
                image={tyreseHeadshot}
                name="Tyrese Brown"
                position="Owner"
              />
              <EmployeeHeadShot
                image={madisonHeadshot}
                name="Madison Sinatra"
                position="Owner"
              />
              {/* <EmployeeHeadShot
                image="https://eightfourthree-events.s3.us-east-2.amazonaws.com/testing/horizontal_image.png"
                name="Randall Schwemmer"
                position="Developer"
              /> */}
            </Box>
          )}
          <Stack
            spacing={4}
            alignItems="center"
            sx={{
              height: "100%",
              width: "100%",
              pt: isMobile ? "10px" : "40px",
              backgroundColor: "#1A2958",
            }}
          >
            {!isMobile && (
              <Typography variant="h1" color="white" fontSize={60}>
                Services We Offer
              </Typography>
            )}
            <Box
              display="flex"
              flexDirection={isMobile ? "column" : "row"}
              alignItems="center"
              width={isMobile ? "100%" : "75%"}
              justifyContent="space-between"
              paddingX={isMobile ? 0 : 8}
              gap={isMobile ? 2 : 0}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#147BE1",
                  borderRadius: 8,
                  minWidth: isMobile ? "60%" : "20%",
                }}
                onClick={openAdSpace}
              >
                Info on AD Space
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#147BE1",
                  borderRadius: 8,
                  minWidth: isMobile ? "60%" : "20%",
                }}
                onClick={openRecommend}
              >
                Recommend an Event
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#147BE1",
                  borderRadius: 8,
                  minWidth: isMobile ? "60%" : "20%",
                }}
                onClick={openExpand}
              >
                Franchising Opportunity
              </Button>
            </Box>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <Grid container spacing={2} justifyContent="center" width="100%">
                <Grid item xs={6} sm={5} md={3}>
                  <ServiceCard
                    service1="SEO"
                    service2="Optimization"
                    image={seoImg}
                    description="Elevate your online visibility with our expert SEO services. We strategically optimize your website for local search, enhance Google Maps rankings, and build a strong online presence to drive qualified leads."
                  />
                </Grid>
                <Grid item xs={6} sm={5} md={3}>
                  <ServiceCard
                    service1="Social Media"
                    service2="Management"
                    image={socialImg}
                    description="Strengthen your brand engagement and reach your Charleston audience with 843 Hub&#39;s strategic social media management. We cultivate a thriving online community, amplify brand awareness, and implement data-driven strategies to achieve tangible business results."
                  />
                </Grid>
                <Grid item xs={6} sm={5} md={3}>
                  <ServiceCard
                    service1="Website"
                    service2="Development"
                    image={webDevImg}
                    description="Create a powerful digital presence with a professional website or mobile application. We create user-centric, high-performing websites and custom apps designed to facilitate significant business growth in the Charleston market."
                  />
                </Grid>
                <Grid item xs={6} sm={5} md={3}>
                  <ServiceCard
                    service1="Video"
                    service2="Production"
                    image={videoImage}
                    description="Expand your market and drive audience engagement with our high-quality video production services. We enhance your brand storytelling and captivate leads with professional cinematography. Achieve your business objectives through compelling drone and ground media today."
                  />
                </Grid>
              </Grid>
            </Box>
            <AboutUsFooter />
          </Stack>
        </Stack>
        <AdSpaceDialog isOpen={adSpaceOpen} closeDialog={handleAdClose} />
        <ExpandNearYouDialog
          isOpen={expandOpen}
          closeDialog={handleExpandClose}
        />
        <RecommendEventDialog
          isOpen={recommendOpen}
          closeDialog={handleRecommendClose}
        />
      </Box>
    </>
  )
}

export default AboutUs
